import React from "react";
import { Alert, Box, CircularProgress, Stack } from "@mui/material";
import { useParams } from "react-router-dom";
import MonitoringHeader from "../components/MonitoringHeader";
import DripSessionDetailsCard from "../components/DripSessionDetailsCard";
import { getDripSessionById } from "../api/dripSessionsApi";
import { prettyError } from "../utils/prettyError";

export default function DripSessionDetailsPage() {
  const { sessionId } = useParams();

  const [session, setSession] = React.useState(null);
  const [loading, setLoading] = React.useState(true);
  const [error, setError] = React.useState("");

  const fetchDetails = React.useCallback(async () => {
    try {
      setLoading(true);
      setError("");
      const data = await getDripSessionById(sessionId);
      setSession(data);
    } catch (err) {
      setError(prettyError(err));
      setSession(null);
    } finally {
      setLoading(false);
    }
  }, [sessionId]);

  React.useEffect(() => {
    fetchDetails();
  }, [fetchDetails]);

  return (
    <Box sx={{ minHeight: "100vh", bgcolor: "#f8fafc", py: 3 }}>
      <Box sx={{ maxWidth: 1200, mx: "auto", px: 2 }}>
        <MonitoringHeader
          title="Drip Session Details"
          subtitle={`View complete details for session ${sessionId}`}
          onRefresh={fetchDetails}
          loading={loading}
        />

        {loading ? (
          <Stack alignItems="center" sx={{ py: 8 }}>
            <CircularProgress />
          </Stack>
        ) : error ? (
          <Alert severity="error">{error}</Alert>
        ) : (
          <DripSessionDetailsCard session={session} />
        )}
      </Box>
    </Box>
  );
}